/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

/**
 * Retrieve elements matching selector
 */
export function getElements<T extends HTMLElement = HTMLElement>(selector: string, context?: HTMLElement): T[] {
    return Array.from((context || document).querySelectorAll<T>(selector));
}

/**
 * Remove element children
 */
export function removeChildren(element: HTMLElement) {
    while (element.firstChild) {
        element.removeChild(element.firstChild);
    }
}

/**
 * Replace existing element matched by selector with element extracted from
 * provided content, matching the same selector.
 */
export function replaceHtml(selector: string, content: string): void {
    const target = document.querySelector<HTMLElement>(selector);
    if (!target) {
        return;
    }

    const doc = (new DOMParser()).parseFromString(content, 'text/html');
    const contentNode = doc.querySelector<HTMLElement>(selector);

    if (!contentNode) {
        return;
    }

    target.parentElement!.replaceChild(contentNode, target);
}
